import { IPointsOfSaleStateInitialState } from 'interfaces/pointsOfSale.interface';

const initialPointsOfSaleState: IPointsOfSaleStateInitialState = {
  pointsOfSale: [],
  pointsOfSaleSelected: null,
  isLoadingGetPointsOfSale: false,
  selectPointOfSale: () => {},
  createPointOfSale: () => Promise.resolve(false),
  updatePointOfSale: () => Promise.resolve(false),
  removePointOfSale: () => Promise.resolve(false),
};

export default initialPointsOfSaleState;
